export const emailRegx =
  /^[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,4}[a-zA-Z]{2,5}$/;

// (/^
//    (?=.*\d)                should contain at least one digit
//    (?=.*[a-z])             should contain at least one lower case
//    (?=.*[A-Z])             should contain at least one upper case
//    [a-zA-Z0-9]{8,}         should contain at least 8 from the mentioned characters
// $/)
export const passowrdRegx =
  /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
// /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{7,}$/
export const nameRegex = /^[a-zA-Z\s]*$/;

export const alphanumericRegex = /^[0-9a-zA-Z]+$/;

export const numericRegex = /^[0-9]*$/;

export const httpsWwwRegex = /^https:\/\/www\.[^\s/$.?#].[^\s]*$/i;

export const youtubeRegex =
  /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
